/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import clsx from "clsx";

interface BookingLoginReservationsTableBodyProps {
    className?: string;
    children: React.ReactNode | React.ReactNode[];
}

const BookingLoginReservationsTableBody = (props: BookingLoginReservationsTableBodyProps) => {
    return (
        <div className={clsx("BookingLoginReservationsTableBody", props.className ? props.className : "divide-y divide-solid divide-gray-200")}>
            {props.children}
        </div>
    );
};

export default BookingLoginReservationsTableBody;
